import { useId } from 'react';
import { Select as BaseSelect } from '@base-ui/react/select';
import { Check, ChevronsUpDown } from 'lucide-react';
import FieldFrame from './FieldFrame.jsx';
import Icon from './Icon.jsx';
import { getFieldDescribedBy } from './getFieldDescribedBy.js';

/** Choose one option from a short list. `items` is [{ value, label }]. */
const Select = ({ label, hint, error, items, value, defaultValue, onValueChange, placeholder = 'Select', disabled = false }) => {
  const id = useId();

  return (
    <FieldFrame id={id} label={label} hint={hint} error={error}>
      <BaseSelect.Root items={items} value={value} defaultValue={defaultValue} onValueChange={onValueChange} disabled={disabled}>
        <BaseSelect.Trigger id={id} className="comp-select" aria-invalid={error ? 'true' : undefined} aria-describedby={getFieldDescribedBy({ id, hint, error })}>
          <BaseSelect.Value className="comp-select__value" placeholder={placeholder} />
          <BaseSelect.Icon className="comp-select__icon">
            <Icon icon={ChevronsUpDown} size="sm" />
          </BaseSelect.Icon>
        </BaseSelect.Trigger>
        <BaseSelect.Portal>
          <BaseSelect.Positioner className="comp-select__positioner" sideOffset={6} alignItemWithTrigger={false}>
            <BaseSelect.Popup className="comp-select__popup">
              <BaseSelect.List>
                {items.map((item) => (
                  <BaseSelect.Item key={item.value} value={item.value} className="comp-select__item">
                    <BaseSelect.ItemText>{item.label}</BaseSelect.ItemText>
                    <BaseSelect.ItemIndicator className="comp-select__check">
                      <Icon icon={Check} size="sm" />
                    </BaseSelect.ItemIndicator>
                  </BaseSelect.Item>
                ))}
              </BaseSelect.List>
            </BaseSelect.Popup>
          </BaseSelect.Positioner>
        </BaseSelect.Portal>
      </BaseSelect.Root>
    </FieldFrame>
  );
};

export default Select;
